import { render } from "./ArtboardFrame.vue?vue&type=template&id=3b6256af&scoped=true"
import script from "./ArtboardFrame.vue?vue&type=script&lang=js"
export * from "./ArtboardFrame.vue?vue&type=script&lang=js"

import "./ArtboardFrame.vue?vue&type=style&index=0&id=3b6256af&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b6256af"]])

export default __exports__